/**
 * Generated by orval 🍺
 * Do not edit manually.
 * API Vila Contábil
 * OpenAPI spec version: v1.0.9
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ProfileChangeProfileAvatarBody,
  RelationDataDTO,
  UserAcesse
} from '../../model';

import { apiRequest } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Listar os acessos do usuário (perfis)
 */
export const profileGetMyAcesses = (

 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<UserAcesse[]>(
      {url: `/profile/acesses`, method: 'GET', signal
    },
      options);
    }




export const getProfileGetMyAcessesQueryKey = () => {
    return [
    `/profile/acesses`
    ] as const;
    }


export const getProfileGetMyAcessesQueryOptions = <TData = Awaited<ReturnType<typeof profileGetMyAcesses>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profileGetMyAcesses>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfileGetMyAcessesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof profileGetMyAcesses>>> = ({ signal }) => profileGetMyAcesses(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof profileGetMyAcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProfileGetMyAcessesQueryResult = NonNullable<Awaited<ReturnType<typeof profileGetMyAcesses>>>
export type ProfileGetMyAcessesQueryError = ErrorType<void>


export function useProfileGetMyAcesses<TData = Awaited<ReturnType<typeof profileGetMyAcesses>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof profileGetMyAcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof profileGetMyAcesses>>,
          TError,
          Awaited<ReturnType<typeof profileGetMyAcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfileGetMyAcesses<TData = Awaited<ReturnType<typeof profileGetMyAcesses>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profileGetMyAcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof profileGetMyAcesses>>,
          TError,
          Awaited<ReturnType<typeof profileGetMyAcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfileGetMyAcesses<TData = Awaited<ReturnType<typeof profileGetMyAcesses>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profileGetMyAcesses>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Listar os acessos do usuário (perfis)
 */

export function useProfileGetMyAcesses<TData = Awaited<ReturnType<typeof profileGetMyAcesses>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profileGetMyAcesses>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfileGetMyAcessesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Trocar a foto do perfil
 */
export const profileChangeProfileAvatar = (
    profileChangeProfileAvatarBody: BodyType<ProfileChangeProfileAvatarBody>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`Image`, profileChangeProfileAvatarBody.Image);

      return apiRequest<RelationDataDTO>(
      {url: `/profile/avatar`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getProfileChangeProfileAvatarMutationKey = () => ['profileChangeProfileAvatar'] as const;

export const getProfileChangeProfileAvatarMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profileChangeProfileAvatar>>, TError,ProfileChangeProfileAvatarMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof profileChangeProfileAvatar>>, TError,ProfileChangeProfileAvatarMutationVariables, TContext> => {

const mutationKey = getProfileChangeProfileAvatarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof profileChangeProfileAvatar>>, ProfileChangeProfileAvatarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  profileChangeProfileAvatar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProfileChangeProfileAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof profileChangeProfileAvatar>>>
    export type ProfileChangeProfileAvatarMutationBody = BodyType<ProfileChangeProfileAvatarBody>
    export type ProfileChangeProfileAvatarMutationError = ErrorType<void>
    export type ProfileChangeProfileAvatarMutationVariables = {data: BodyType<ProfileChangeProfileAvatarBody>}

    /**
 * @summary Trocar a foto do perfil
 */
export const useProfileChangeProfileAvatar = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profileChangeProfileAvatar>>, TError,ProfileChangeProfileAvatarMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof profileChangeProfileAvatar>>,
        TError,
        ProfileChangeProfileAvatarMutationVariables,
        TContext
      > => {
      return useMutation(getProfileChangeProfileAvatarMutationOptions(options), queryClient);
    }
